import { ReactElement } from 'react';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

// Components.
import { IModalProps, Modal, ModalVariants } from '@comptia-sso/core';
import { RedeemAccessKeys } from '../RedeemAccessKeys';

// Styles.
import styles from './RedeemModal.module.scss';

export const RedeemModal = (props: IModalProps): ReactElement => {
  const { onClose, ...modalProps } = props;

  return (
    <Modal
      {...modalProps}
      disableClose
      disableHeader
      onClose={onClose}
      variant={ModalVariants.Small}
    >
      <button
        aria-label="Close Profile Menu"
        className={styles.close}
        onClick={onClose}
        type="button"
      >
        <HighlightOffIcon />
      </button>
      <div className={styles.content}>
        <RedeemAccessKeys onSuccess={onClose} />
      </div>
    </Modal>
  );
};
